import { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Label, TextInput } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechasInterface } from "../../../../../interfaces/FechasInterface";
import { ReferenciasVecinalesInterface } from "../../../../../interfaces/ReferenciasVecinalesInterface";
import { NotasRVInterface } from "../../../../../interfaces/NotasRVInterface";
import BarraReferenciaV from "../../../../../img/Barra_ReferenciaV.png";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import fotoMapa from "../../../../../img/fotoMapa.png";

export const VecinalesListaPrint = () => {
  const tituloFormulario = "REFERENCIAS VECINALES";
  const { control, handleSubmit, setValue, reset } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const [edad, setEdad] = useState<number | null>(null);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");

  const formFields = [
    { label: "NOMBRE:", id: "nombre" },
    { label: "DOMICILIO:", id: "domicilio" },
    { label: "TELÉFONO:", id: "telefono" },
    { label: "OCUPACIÓN:", id: "ocupacion" },
    { label: "AÑOS DE CONOCER AL EVALUADO:", id: "anios-conocerlo" },
    { label: "COMENTARIOS:", id: "comentarios" },
    { label: "LO RECOMIENDA:", id: "como-conoce" },
  ];

  const [formData, setFormData] = useState({});

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleFechaNacimientoChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const nuevaFechaNacimiento = event.target.value;
    setFechaNacimiento(nuevaFechaNacimiento);

    const nuevaEdad = calcularEdad(nuevaFechaNacimiento);
    setEdad(nuevaEdad);
  };

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFecha = useGetData<FechasInterface[]>({
    url: `/evaluado/${evaluadosList_id}/fecha-visita-bienesinmuebles`,
    name: ["fecha-visita-bienesinmuebles"],
  });

  const queryVecinales = useGetData<ReferenciasVecinalesInterface>({
    url: `/referencia_vecinal/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "referencia_vecinal"],
  });

  const queryNotasRV = useGetData<NotasRVInterface[]>({
    url: `/notas_rv/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "notas_rv"],
  });

  const generoMap: { [key: string]: string } = {
    M: "Masculino",
    F: "Femenino",
    O: "Otro",
  };

  const generoTexto =
    generoMap[queryEvaluado.data?.genero as string] || "No especificado";

  useEffect(() => {
    console.log(queryEvaluado.data);
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: queryEvaluado.data.fecha_nacimiento || "",
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (queryVecinales.data) {
      const rp = queryVecinales.data;
      reset({
        nombre_rv1: rp.nombre_rv1 || "",
        domicilio_rv1: rp.domicilio_rv1 || "",
        telefono_rv1: rp.telefono_rv1 || "",
        ocupacion_rv1: rp.ocupacion_rv1 || "",
        anios_conocerlo_rv1: rp.anios_conocerlo_rv1 || "",
        comentarios_rv1: rp.comentarios_rv1 || "",
        lo_recomienda_rv1: rp.lo_recomienda_rv1 || "",
        nombre_rv2: rp.nombre_rv2 || "",
        domicilio_rv2: rp.domicilio_rv2 || "",
        telefono_rv2: rp.telefono_rv2 || "",
        ocupacion_rv2: rp.ocupacion_rv2 || "",
        anios_conocerlo_rv2: rp.anios_conocerlo_rv2 || "",
        comentarios_rv2: rp.comentarios_rv2 || "",
        lo_recomienda_rv2: rp.lo_recomienda_rv2 || "",
      });
    }
  }, [queryVecinales.data, reset]);

  useEffect(() => {
    if (queryNotasRV.data && queryNotasRV.data.length > 0) {
      const registroValido = queryNotasRV.data.find((item) => item.nota_rv);

      if (registroValido) {
        setValue("nota_rv", registroValido.nota_rv);
      }
    }
  }, [queryNotasRV.data, setValue]);

  return (
    <div className="max-w-[800px] mx-auto p-4 bg-white">
      {/* Marca de agua */}
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>
      <div className="space-y-1 p-1 mt-2">
        <div className="grid grid-cols-3 gap-2">
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fecha_bienesinmuebles" className="mr-2">
              FECHA VISITA:
            </Label>
            <Controller
              name="fecha_refv"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextInput
                  id="fecha_refv"
                  name="fecha_refv"
                  type="date"
                  value={
                    queryFecha.data && queryFecha.data.length > 0
                      ? queryFecha.data[0].fecha_refv || ""
                      : ""
                  }
                  disabled={true}
                />
              )}
            />
          </div>
          <div className="col-span-2">
            <Label htmlFor="nombre">NOMBRE:</Label>
            <TextInput
              id="nombre"
              name="nombre"
              value={`${queryEvaluado.data?.nombre || ""} ${
                queryEvaluado.data?.apellido_paterno || ""
              } ${queryEvaluado.data?.apellido_materno || ""}`}
              onChange={handleInputChange}
              disabled={true}
            />
          </div>
          {/* Campo para RFC */}
          <div className="col-span-1">
            <Label htmlFor="rfc">RFC:</Label>
            <TextInput
              id="rfc"
              name="rfc"
              onChange={handleInputChange}
              value={queryEvaluado.data?.rfc || ""}
              disabled={true}
            />
          </div>
          {/* Edad */}
          <div className="col-span-1">
            <Label htmlFor="edad">EDAD:</Label>
            <TextInput
              id="edad"
              name="edad"
              value={edad !== null ? edad.toString() : ""}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="sexo">SEXO:</Label>
            <TextInput
              id="sexo"
              name="sexo"
              value={generoTexto}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="estadoCivil">ESTADO CIVIL:</Label>
            <TextInput
              id="estadoCivil"
              name="estadoCivil"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.estado_civil || ""}`}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="escolaridad">ESCOLARIDAD:</Label>
            <TextInput
              id="escolaridad"
              name="escolaridad"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.escolaridad || ""}`}
              disabled={true}
            />
          </div>
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fechaNacimiento" className="mr-2">
              FECHA DE NACIMIENTO:
            </Label>
            <TextInput
              id="fechaNacimiento"
              name="fechaNacimiento"
              value={`${queryEvaluado.data?.fecha_nacimiento || ""}`}
              disabled={true}
              type="date"
              onChange={handleInputChange}
              className="w-32"
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="curp">CURP:</Label>
            <TextInput
              id="curp"
              name="curp"
              onChange={handleInputChange}
              value={queryEvaluado.data?.curp || ""}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="empresa">EMPRESA:</Label>
            <TextInput
              id="empresa_id"
              name="empresa"
              value={queryEvaluado.data?.empresa_id?.nombre || ""}
              onChange={handleInputChange}
              disabled={true}
            />
          </div>
        </div>
      </div>
      <div className="bg-slate-100 p-0.5 rounded-lg mt-2">
        <img
          src={BarraReferenciaV}
          alt="HeaderDatosGenerales"
          className="rounded-lg h-auto max-h-20"
        />
      </div>
      <div className="bg-blue-100 text-center font-semibold text-gray-700 border-b border-gray-300">
        REFERENCIA VECINAL 1
      </div>
      <div className="relative">
        <table className="w-full border-collapse">
          <tbody>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                NOMBRE:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="nombre_rv1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="nombre_rv1"
                      value={
                        field.value || queryVecinales.data?.nombre_rv1 || ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                DOMICILIO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="domicilio_rv1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="domicilio_rv1"
                      value={
                        field.value || queryVecinales.data?.domicilio_rv1 || ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                TELÉFONO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="telefono_rv1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="telefono_rv1"
                      value={
                        field.value || queryVecinales.data?.telefono_rv1 || ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                OCUPACIÓN:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="ocupacion_rv1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="ocupacion_rv1"
                      value={
                        field.value || queryVecinales.data?.ocupacion_rv1 || ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                AÑOS DE CONOCERLO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="anios_conocerlo_rv1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="anios_conocerlo_rv1"
                      value={
                        field.value ||
                        queryVecinales.data?.anios_conocerlo_rv1 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                COMENTARIOS:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="comentarios_rv1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="comentarios_rv1"
                      value={
                        field.value ||
                        queryVecinales.data?.comentarios_rv1 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                LO RECOMIENDA:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="lo_recomienda_rv1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="lo_recomienda_rv1"
                      value={
                        field.value ||
                        queryVecinales.data?.lo_recomienda_rv1 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="mt-[150px]"></div>
      <div className="bg-blue-100 text-center font-semibold text-gray-700 border-b border-gray-300">
        REFERENCIA VECINAL 2
      </div>
      <div className="relative">
        <table className="w-full border-collapse">
          <tbody>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                NOMBRE:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="nombre_rv2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="nombre_rv2"
                      value={
                        field.value || queryVecinales.data?.nombre_rv2 || ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                DOMICILIO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="domicilio_rv2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="domicilio_rv2"
                      value={
                        field.value || queryVecinales.data?.domicilio_rv2 || ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                TELÉFONO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="telefono_rv2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="telefono_rv2"
                      value={
                        field.value || queryVecinales.data?.telefono_rv2 || ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                OCUPACIÓN:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="ocupacion_rv2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="ocupacion_rv2"
                      value={
                        field.value || queryVecinales.data?.ocupacion_rv2 || ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                AÑOS DE CONOCERLO:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="anios_conocerlo_rv2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="anios_conocerlo_rv2"
                      value={
                        field.value ||
                        queryVecinales.data?.anios_conocerlo_rv2 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                COMENTARIOS:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="comentarios_rv2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="comentarios_rv2"
                      value={
                        field.value ||
                        queryVecinales.data?.comentarios_rv2 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-0.5 font-semibold w-3/4 text-xs">
                LO RECOMIENDA:{" "}
              </td>
              <td className="border border-gray-300 p-0.5 text-xs">
                <Controller
                  name="lo_recomienda_rv2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      type="text"
                      id="lo_recomienda_rv2"
                      value={
                        field.value ||
                        queryVecinales.data?.lo_recomienda_rv2 ||
                        ""
                      }
                      disabled={true}
                      onChange={(e) => field.onChange(e.target.value)}
                      className="text-left w-auto border rounded text-xs leading-tight"
                    />
                  )}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="mt-[450px]"></div>
      <div className="p-4 border-t border-gray-300">
        <div className="text-center mt-4">
          <p className="text-left text-xs text-gray-600">
            Bajo protesta de decir verdad, hago constar que los datos
            proporcionados son verdaderos. Asimismo, autorizo a la empresa SKA
            TRACKING AND SECURITY S.A. de C.V. para que proporcione toda la
            información, documentos y todos los datos que derive de las
            evaluaciones de pruebas de confianza que se me realicen.
          </p>
        </div>
        <div className="flex justify-end">
          <p className="text-right text-xs text-gray-600">
            ___________________________
            <br />
            Nombre y Firma del Evaluado
          </p>
        </div>
      </div>
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>
      {/* Marca de agua */}
      <div className="absolute inset-0 top-[150%] flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Marca de agua */}
      <div className="absolute inset-0 top-[250%] flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Sección de Notas */}
      <div className="border border-gray-300 mt-4">
        <div className="bg-blue-100 p-2 text-center font-semibold text-gray-700 border-b border-gray-300">
          NOTAS
        </div>
        <Controller
          name="nota_rv"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <textarea
              className="w-full p-2 min-h-[100px] text-sm text-gray-900 border-0 focus:ring-0 resize-none"
              aria-label="nota_rv"
              {...field}
              value={
                field.value ||
                (queryNotasRV.data && queryNotasRV.data.length > 0
                  ? queryNotasRV.data[0]?.nota_rv || ""
                  : "")
              }
              onInput={(e) => {
                const target = e.target as HTMLTextAreaElement;
                target.style.height = "auto";
                target.style.height = `${target.scrollHeight}px`;
              }}
              style={{ height: "auto", overflow: "hidden" }}
            />
          )}
        />
      </div>
      <div className="mt-[450px]"></div>
      <div className="p-4 border-t border-gray-300">
        <div className="text-center">
          <p className="text-left text-xs text-gray-600">
            Bajo protesta de decir verdad, hago constar que los datos
            proporcionados son verdaderos. Asimismo, autorizo a la empresa SKA
            TRACKING AND SECURITY S.A. de C.V. para que proporcione toda la
            información, documentos y todos los datos que derive de las
            evaluaciones de pruebas de confianza que se me realicen.
          </p>
        </div>
        <div className="flex justify-end">
          <p className="text-right text-xs text-gray-600">
            ___________________________
            <br />
            Nombre y Firma del Evaluado
          </p>
        </div>
      </div>
    </div>
  );
};
